import React, { useState, useEffect, useContext } from 'react';
import * as S from './styles';
import { Context } from '../../services/contexts/StateContext';
import api from '../../services/api';
import Cookies from 'js-cookie';
import MaskedInput from 'react-text-mask';
import { FaListUl, FaBan } from 'react-icons/fa';

//---------COMPONENTES----------------------
import Header from '../../componentes/Header/index';
import Footer from '../../componentes/Footer/index';

import ModalVeiculo from '../../componentes/Modal/ModalVeiculo';
import { Functions, SetFunctions } from '../../componentes/Functions';
import { PesquisaPlaca } from "../../componentes/Pesquisas/PesquisaPlaca";
import { Validar_Representante } from '../../componentes/Cadastro/Validar_Representante';
import { ModalAddFranquia } from '../../componentes/Modal/ModalAddFranquia';
import { ModalCotacao_PREVIEW } from '../../componentes/Modal/ModalCota_PREVIEW';
import {FoneCelular} from '../../componentes/Cadastro/FoneCelular';

//---------SERVICES--------------------------
import { Api_Clientes } from '../../services/FiltrosApi/clienteApi';
import { Api_Veiculos } from '../../services/FiltrosApi/veiculos_api';
import { API_Franquia } from '../../services/FiltrosApi/franquiaApi';
import { ApiUsuario } from '../../services/FiltrosApi/logado';
import { buscarDadosPlaca } from '../../services/Api_PlacaFipe';

// --------COTAÇÃO----------
import ModeloCotacao from './ModeloCotacao';

// ------------------------------------------
function COTACAO() {
    const { state, dispatch } = useContext(Context);
    const { cliente, usuario, logado } = state.cliente;
    const { veiculo, cotacao } = state.veiculo;
    const { franquia, foneCelular } = state.franquia;
    const { parametroInit, playmodal, listaPesquisa, playLista } = state.parametros;
    const { pesquisaIdVeiculo, pesquisaIdUsuario } = parametroInit;

    const { id_Usuario } = usuario;

    const { LogUsuario } = ApiUsuario();
    const { Play_Modal_Add } = Functions();
    const { SetFranquia, SetVeiculo, SetParametroInit } = SetFunctions();

    const { pesqidcliente } = Api_Clientes();
    const { PesqVeiculoPlaca, AtualizarVeiculo, AddPlaca, pesqIDveiculo, pesqCotacao_Id, AddCotacao, AtualizarCotacao, AtualizarRegistro } = Api_Veiculos();
    const {AddFranquia, PesqFranquiaCPF, PesqFranquiaID } = API_Franquia();
    
    // ----------------------
    const token = Cookies.get('token');
    // ----------------------------

    const [mostrarModalCelular, setMostrarModalCelular] = useState(false);

    const [erroNumero, setErroNumero] = useState('');
    const [valorMensalCotac, setvalorMensal] = useState('');
    const [listaFiltro, setlistaFiltro] = useState([]);
    // ------------------------------------

    const [buscandoDadosPlaca, setBuscandoDadosPlaca] = useState(false);
    const [sucessoBuscaPlaca, setSucessoBuscaPlaca] = useState(false);
    const [dadosFipeRecebidos, setDadosFipeRecebidos] = useState(null);
    const [dadosDivergentes, setDadosDivergentes] = useState(false);
    const [dadosCompletos, setdadosCompletos] = useState(false);
    const [cpfValidado, setCpfValidado] = useState(false);
    const [showModalAddFranquia, setShowModalAddFranquia] = useState(false);
    const [erroBuscaPlaca, setErroBuscaPlaca] = useState('');
    const [situacaoDivergente, setSituacaoDivergente] = useState(false); 
    const [maioresScoresFipe, setmaioresScoresFipe] = useState([]);
    const [valorFipeNumerico, setValorFipeNumerico] = useState(null);
    const [motrarLista, setMotrarLista] = useState(false);
    // ----------------------------
    
    const SetCelularFranquia = (key, value) => {
        dispatch({
            type: 'set_foneFranquia',
            payload: { ...foneCelular, [key]: value }
        });
    };

    // -----------------
    useEffect(() => {
        // Verificar se existe validação salva no localStorage
        const validacaoSalva = localStorage.getItem(`cpf_validado`);

        if (validacaoSalva) {
            try {
                const { timestamp, validado, nome, franquiaId } = JSON.parse(validacaoSalva);
                const agora = new Date().getTime();
                const tempoDecorrido = agora - timestamp;
                const vintequatroHoras = 24 * 60 * 60 * 1000; // 24 horas em milissegundos

                // Se ainda está dentro das 24h, usar validação salva
                if (tempoDecorrido < vintequatroHoras && validado) {
                    dispatch({
                        type: 'SET_Franquia',
                        payload: {
                            ...franquia,
                            id: franquiaId,
                            nome: nome,
                        }
                    });
                    setCpfValidado(true);
                    console.log('✅ Validação de CPF encontrada no localStorage (válida por 24h)');
                } else {
                    // Validação expirada, limpar localStorage
                    console.log('⏰ Validação de CPF expirada (mais de 24h)');
                    localStorage.removeItem(`cpf_validado`);
                    setCpfValidado(false);
                }
            } catch (error) {
                console.error('Erro ao ler validação do localStorage:', error);
                setCpfValidado(false);
            }
        } else {
            // Não há validação salva, resetar
            setCpfValidado(false);
        }
    }, []);
    // --------------------------

    useEffect(() => {
        if (token) {
            LogUsuario(token);
        } else {
            dispatch({
                type: 'set_logado',
                payload: { ...logado, conectado: false }
            });
        }
    }, [token]);

    //-----------------------------------------------
    useEffect(() => {
        if (pesquisaIdVeiculo) {
            pesqIDveiculo();
        }
    }, [pesquisaIdVeiculo])

    // -------------------
    useEffect(() => {
        if (pesquisaIdUsuario) {
            pesqIdUsuario();
        }
    }, [pesquisaIdUsuario])

    //--Pesquisar Usuario por id----------------------------
    async function pesqIdUsuario() {
        if (id_Usuario) {
            await api.get(`/usuario/id/${id_Usuario}`)
            .then(res => {
                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: { ...listaPesquisa, listaUsuario: [res.data] }
                });
                dispatch({
                    type: 'set_playLista',
                    payload: { ...playLista, playListaUsuario: true }
                });
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, pesquisaIdUsuario: false }
                });

            })
        }
    };

    // ------------------------------
    useEffect(() => {
        pesqidcliente();
    }, [cliente.id_Cliente]);

    // ---------------------------------
    useEffect(() => {
        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                detalhesLista: false,
                playModalDetalhesEven: false,
            }
        });
    }, [parametroInit.filtroPlaca]);
    
    // Estado para controlar a exibição do ModeloCotacao
    const [mostrarCotacao, setMostrarCotacao] = useState(false);

    const handleMostrarCotacao = (cotacaoItem) => {
        dispatch({
            type: 'set_cotacao',
            payload: {
                ...cotacao,
                id_Cotacao: cotacaoItem._id,
                valorCotacao: cotacaoItem.valorCotacao,
                valorAdesao: cotacaoItem.valorAdesao,
            }
        });
        setMostrarCotacao(true);
    };

    const handleCancelarCotacao = async (idItem) => {
        if (!window.confirm('Deseja cancelar esta cotação?')) return;
        try {
            let res = await AtualizarRegistro({ idRegistro: idItem, status: 'E' });
            res? await pesqCotacao_Id() : alert('Erro ao cancelar cotação. Tente novamente.');
        } catch (error) {
            console.error('Erro ao cancelar cotação:', error.message);
            alert('Erro ao cancelar cotação.');
        }
    };
    // ----------------------
    const handleNovaCotacao = () => {
        setMotrarLista(false);
        setErroNumero('');
        dispatch({
            type: 'set_veiculo',
            payload: {
                ...veiculo,
                whatsapp_Cotacao: '',
                valorAdesao: '',
            }
        });
    };
    // Função para mostrar a lista de cotações
    const handleMostrarLista = () => {
        setMotrarLista(true);
    };

    // --------

    useEffect(() => {
        dispatch({
            type: 'SET_PLAYMODAL',
            payload: {
                ...playmodal,
                playModalEven: true,
            }
        });
    }, []);
    // ------------------------------

    const desconectarFranquia = () => {        
        const confirmar = window.confirm('Deseja Desconectar o Representante?');
        if (confirmar) {
            localStorage.removeItem(`cpf_validado`);
            setCpfValidado(false);
            LimparDados();
        }
    };
    // -------------------------------

    function FecharModalAddFranquia() {
        setShowModalAddFranquia(false)
        LimparDados();
    };
    // --------------------------------
    function LimparDados() {
        dispatch({
            type: 'set_limparFranquia',
        });

        dispatch({
            type: 'set_limparVeiculo',
        });
        
        dispatch({
            type: 'set_foneFranquia',
            payload: {
                ...foneCelular,
                numeroCel: '',
            }
        });

        dispatch({
            type: 'set_ListaPesquisa',
            payload: {  
                ...listaPesquisa,
                listaFranquia: [],
                nomeItem: '',
            }
        });
    };

    // Verificar se precisa mostrar modal de celular
    useEffect(() => {
        if (franquia.id && !foneCelular.numeroCel) {
            setMostrarModalCelular(true);
        } else {
            setMostrarModalCelular(false);
        };

        if (franquia.id) {
            setShowModalAddFranquia(false);
        }
    }, [franquia.id, foneCelular.numeroCel]);
    // ------------------------------
    
    useEffect(() => {
        if (showModalAddFranquia && franquia.cpfCnpj.length >= 11) {
            PesqFranquiaCPF(franquia.cpfCnpj);
        }
      
    }, [franquia.cpfCnpj])
    // -----------------------------

    useEffect(() => {
        if (showModalAddFranquia && franquia.id) {
            alert('Representante já cadastrado!');
            dispatch({
                type: 'set_ListaPesquisa',
                payload: {  
                    ...listaPesquisa,
                    listaFranquia: [],
                }
            });
            dispatch({
                type: 'set_limparFranquia',
            });
        };

        if (franquia.id && !showModalAddFranquia) {
            PesqFranquiaID(franquia.id);
        };
    }, [franquia.id])

    // -----------------
    useEffect(() => {
        if (listaPesquisa.listaFranquia.length > 0) {
            const franquiaBD = listaPesquisa.listaFranquia[0];

            dispatch({
                type: 'set_foneFranquia',
                payload: {
                    ...foneCelular,
                    numeroCel: franquiaBD?.foneCelular.numeroCel || '',
                }
            });

            if (showModalAddFranquia) {
                dispatch({
                    type: 'SET_Franquia',
                    payload: {
                        ...franquia,
                        cpfCnpj: franquiaBD?.cpfCnpj || '',
                        id: franquiaBD?._id || '',
                    }
                });
            }
        } 
    }, [listaPesquisa.listaFranquia]);   

    // -----------------
    // AddPlaca caso o veiculo nao exista em listaPesquisa.listaVeiculo.
    // Função para salvar novo veículo com dados da FIPE
    useEffect(() => {
        if (listaPesquisa.listaVeiculo.length === 0 && dadosFipeRecebidos && veiculo.tipo && veiculo.modelo) {
            console.log('Adicionar novo veículo ao sistema.');
            AddPlaca();
        }
    }, [dadosFipeRecebidos, veiculo.tipo, veiculo.modelo]);

     
    // Atualizar veículo existente quando dados da FIPE forem recebidos
    useEffect(() => {
        if(listaPesquisa.listaVeiculo.length > 0 && dadosFipeRecebidos && !dadosCompletos && dadosDivergentes){
            AtualizarVeiculo({idCliente: null});
            setdadosCompletos(true);
            setDadosDivergentes(false);
        }
        
    }, [listaPesquisa.listaVeiculo, dadosFipeRecebidos, veiculo.valorFipe, veiculo.tipo]);
    // -------------------------

    useEffect(() => {
        if (listaPesquisa.nomeItem?.length === 7) {
            PesqVeiculoPlaca(listaPesquisa.nomeItem);
            setDadosFipeRecebidos(null);
        } else {
            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    listaVeiculo: [],
                }
            });

            setDadosDivergentes(false);
            setdadosCompletos(false);
        };

        if (listaPesquisa.nomeItem.length === 0){
            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    listaFranquia: [],
                }
            });

            setlistaFiltro([]);
        };

        if (listaPesquisa.nomeItem && (listaPesquisa.nomeItem !== veiculo.placa)) {
            setvalorMensal('');
            setMotrarLista(false);
            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    listaVeiculo: [],
                    listaCotacao: [],
                }
            });

            dispatch({
                type: 'set_limparVeiculo',
            });
        }

    }, [listaPesquisa.nomeItem]);
    
    // ------------------------

    useEffect(() => {
        if (listaPesquisa.listaFranquia.length > 0){
            const filtro = listaPesquisa.listaFranquia.filter((item) =>
                item.nome.toLowerCase().includes(listaPesquisa.nomeItem.toLowerCase())
            );
            setlistaFiltro(filtro? filtro : []);
        };
    }, [listaPesquisa.nomeItem, listaPesquisa.listaFranquia]);
    // -----------------------

    useEffect(() => {
      if(listaPesquisa.nomeItem && listaFiltro.length === 0){
            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    alertaNovo: true,
                }
            });
        }
    }, [listaFiltro]);
    // --------------------

    useEffect(() => {
        if (parametroInit.NaoLocalizado) {
            dispatch({
                type: 'SET_PLAYMODAL',
                payload: { ...playmodal, playModalVeiculo: true }
            });
        };

    }, [parametroInit.NaoLocalizado])
    // ---------------------------

    useEffect(() => {
        if (listaPesquisa.listaVeiculo.length > 0) {
            const t = listaPesquisa.listaVeiculo[0];

            dispatch({
                type: 'set_veiculo',
                payload: {
                    ...veiculo,
                    id_Veiculo: t?._id,
                    id_ClienteVeiculo: t?.id_Cliente?._id || "",
                    tipo: t?.tipo,
                    placa: t?.placa,
                    modelo: t?.modelo,
                    anoMod: t?.anoMod,
                    cor: t?.cor,
                    marca: t?.marca,
                    valorFipe: t?.valorFipe,
                    situacao: t?.situacao,
                }
            });
        };
    }, [listaPesquisa.listaVeiculo]);

    // --------FUNÇÃO PARA BUSCAR DADOS DA PLACA VIA API FIPE
    const BuscarPlacaFipe = async (placa) => {
        setBuscandoDadosPlaca(true);
        setErroBuscaPlaca('');
        setSucessoBuscaPlaca(false);
        setDadosDivergentes(false);
        setSituacaoDivergente(false);
        setmaioresScoresFipe([]);
        setDadosFipeRecebidos(null);
        setValorFipeNumerico(null);
        SetParametroInit('DadosLocalizado', false);

        try {
            const dadosFipeVeiculo = await buscarDadosPlaca(placa);
            if (dadosFipeVeiculo.marca === "") {
                SetParametroInit('NaoLocalizado', true);
                alert("Veiculo Não Localizado!");
                return;
            };

            SetParametroInit('DadosLocalizado', true);
            setDadosFipeRecebidos(dadosFipeVeiculo);
            setmaioresScoresFipe(dadosFipeVeiculo.maioresScoresFipe || []);

            // dadosFipeVeiculo.situacao verificar se no texto tem a palavra "roubo" ou "furto"
            if (dadosFipeVeiculo.situacao !== "") {
                if (dadosFipeVeiculo.situacao.toLowerCase() !== "Sem restrição".toLowerCase()) {
                    alert(`⚠️ Atenção: Veículo ${placa} está com situação: "${dadosFipeVeiculo.situacao}".`);
                    setSituacaoDivergente(true);
                }
            }

            setSucessoBuscaPlaca(true);
            setTimeout(() => setSucessoBuscaPlaca(false), 3000);

        } catch (error) {
            setErroBuscaPlaca('Não foi possível buscar os dados da placa. Verifique se a placa está correta.');
            setTimeout(() => setErroBuscaPlaca(''), 5000);
        } finally {
            setBuscandoDadosPlaca(false);
        }
    };
    // ------------------------------

    useEffect(() => {
      const fetchCotacao = async () => {
        const cotacao = await pesqCotacao_Id();
        dispatch({
            type: 'set_cotacao',
            payload: { 
                ...cotacao,
                id_Cotacao: cotacao?._id,
            }
        });

      };
      fetchCotacao();
    }, [veiculo.id_Veiculo]);
    
    // --------------------------------------

     async function GerarCotacao() {
        const whatsapp = veiculo.whatsapp_Cotacao.replace(/\D/g, ''); // Remove tudo que não for número
        if (whatsapp.length < 11) {
            setErroNumero('WhatsApp deve conter no mínimo 11 dígitos (DDD + número).');
        }
        else {
            setErroNumero('');
            if (listaPesquisa.listaCotacao.length > 0) {
                let data = await AtualizarCotacao();
                if (data) {
                    let cotacao = await pesqCotacao_Id();
                    // Filtrar cotacao.registros para obter o ultimo registros.data, usando Filter.
                    let ultimoRegistro = cotacao.registros?.filter(registro => registro.data).sort((a, b) => new Date(b.data) - new Date(a.data))[0];
                    handleMostrarCotacao(ultimoRegistro);
                }else{
                    alert('Erro ao atualizar cotação. Tente novamente.')
                }
            }else {
                let data = await AddCotacao();  
                data? setMostrarCotacao(true) : alert('Erro ao adicionar cotação. Tente novamente.');
            }
        }
    };
    // ------------------------------
    

    useEffect(() => {
      if (listaPesquisa.listaCotacao.length > 0) {
        setMotrarLista(true);
      }
    }, [listaPesquisa.listaCotacao]);

    //###################################################################################################
    return (
        <S.App
        fundoBloque = {showModalAddFranquia || parametroInit.NaoLocalizado}
        >
            <Header playLogo={true} />

            <div className='fundoBloque'/>
            <S.body>
                <S.VistoriaModal>
                    <S.div3>
                        <div className='titulo'>
                            <div className={'tituloUser'}>
                                <span>NOVA COTAÇÃO</span>
                            </div>
                        </div>
    
                        {/* ---REPRESENTANTE---- */
                        !cpfValidado ?
                        <Validar_Representante
                        cpfValidado={cpfValidado}
                        setCpfValidado={setCpfValidado}
                        Play_Modal_Add={Play_Modal_Add}
                        setShowModalAddFranquia={setShowModalAddFranquia}
                        />
                        :
                        <span style={{color:"white"}}> 
                        Ola, 
                            <span 
                            onClick={desconectarFranquia}
                            style={{
                                color:"#00D594", 
                                textTransform:"capitalize", 
                                cursor:"pointer"}}
                            > {franquia.nome} </span> 
                            Faça sua Cotação
                        </span>
                        }    
    
                        {/* Modal para adicionar nova franquia */}
                        <ModalAddFranquia
                            isOpen={showModalAddFranquia}
                            onClose={() => FecharModalAddFranquia()}
                            franquia={franquia}
                            SetFranquia={SetFranquia}
                            foneCelular={foneCelular}
                            SetCelularFranquia={SetCelularFranquia}
                            AddFranquia={AddFranquia}
                            PesqFranquiaCPF={PesqFranquiaCPF}
                        />                   
                    </S.div3>
                    
                    {
                    cpfValidado && !mostrarModalCelular && !parametroInit.NaoLocalizado &&
                    <>
                    {/* --------- PLACA---------- */}
                    <S.div3>
                        <PesquisaPlaca
                        titulo = "PLACA:"
                        setBuscandoDadosPlaca={setBuscandoDadosPlaca}
                        setSucessoBuscaPlaca={setSucessoBuscaPlaca}
                        setDadosDivergentes={setDadosDivergentes}
                        setDadosFipeRecebidos={setDadosFipeRecebidos}
                        dadosFipeRecebidos={dadosFipeRecebidos}
                        dadosCompletos={dadosCompletos}
                        buscandoDadosPlaca={buscandoDadosPlaca}
                        setdadosCompletos={setdadosCompletos}
                        setErroNumero={setErroNumero}
                        setSituacaoDivergente={setSituacaoDivergente}
                        setErroBuscaPlaca={setErroBuscaPlaca}
                        setValorFipeNumerico={setValorFipeNumerico}
                        maioresScoresFipe={maioresScoresFipe}
                        setmaioresScoresFipe={setmaioresScoresFipe}  
                        valorMensalCotac={valorMensalCotac}
                        valorFipeNumerico={valorFipeNumerico}
                        />
                    </S.div3>

                    <S.Container> 
                        {veiculo.placa &&
                        <S.Modal>
                            <ModalCotacao_PREVIEW 
                            fazerCotacao={true}
                            dadosCompletos={dadosCompletos} 
                            setdadosCompletos={setdadosCompletos}
                            dadosFipeRecebidos={dadosFipeRecebidos}
                            erroBuscaPlaca={erroBuscaPlaca}
                            sucessoBuscaPlaca={sucessoBuscaPlaca}
                            dadosDivergentes={dadosDivergentes}
                            situacaoDivergente={situacaoDivergente}
                            maioresScoresFipe={maioresScoresFipe}
                            setValorFipeNumerico={setValorFipeNumerico}
                            buscandoDadosPlaca={buscandoDadosPlaca}
                            valorMensalCotac={valorMensalCotac}
                            setvalorMensal={setvalorMensal}
                            BuscarPlacaFipe={BuscarPlacaFipe}
                            />
                        </S.Modal>
                        }

                        <S.div3>
                            {/* --------Lista de cotações------------- */
                            !motrarLista && valorMensalCotac &&
                            <div style={{display:"flex", flexDirection:"column", width:"95vw", maxWidth: "500px", justifyContent: 'center'}}>
                                <div style={{display:"flex", flexDirection:"row"}}>
                                    {
                                    listaPesquisa.listaCotacao.length > 0 && !motrarLista && 
                                    <FaListUl
                                        title="Mostrar lista de cotações"
                                        onClick={handleMostrarLista}
                                        style={{
                                            flex: 0.1,
                                            marginTop: '60px',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer',
                                            color: '#00D594',
                                            fontSize: '20px',
                                        }}
                                    />
                                    }

                                    <S.box1 style={{flex: 1, marginTop:"10px", flexDirection:"column", maxWidth: "400px", border:"none", position:"relative"}}>
                                        <div className='listaFlexCol'>
                                            <span style={{fontSize:"14px", fontWeight:"bold"}}>ADESÂO:</span>
                                            <input
                                            value={veiculo.valorAdesao}
                                            onChange={e => {SetVeiculo("valorAdesao",e.target.value)}}
                                            type='number'
                                            placeholder='taxa adesão'
                                            style={{fontSize:"clamp(16px, 3vw, 18px)"}}
                                            />
                                        </div> 
                                        
                                        <div className='listaFlexCol'>
                                            <span style={{fontSize:"14px", fontWeight:"bold"}}>WHATSAPP CLIENTE:</span>
                                            <MaskedInput
                                            mask={[/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                            value={veiculo.whatsapp_Cotacao}
                                            onChange={e => {SetVeiculo("whatsapp_Cotacao",e.target.value.replace(/\D/g, ''))}}
                                            placeholder='Número de whatsapp'
                                            style={{fontSize:"clamp(16px, 3vw, 18px)"}}
                                            />
                                        </div>

                                        {erroNumero && 
                                        <div style={{ color: 'red', marginTop: 10 }}>
                                            {erroNumero}
                                        </div>
                                        }
                                    </S.box1>
                                </div>
                                
                                {/*---------GERAR COTAÇÃO----------- */ 
                                (veiculo.valorAdesao && veiculo.whatsapp_Cotacao.length >= 11) &&
                                <S.divButton>
                                    <button
                                    style={{ display:"flex",alignItems:"center", cursor: "pointer", backgroundColor: "#00FF00", color: "black",  padding: '12px', fontWeight: "bold"}}
                                    type='button'
                                    onClick={() => GerarCotacao()}>
                                    GERAR COTAÇÃO
                                    </button>
                                </S.divButton>
                                }
                            </div>
                            }
                            {/* ---------------------- */}
                            {motrarLista && (
                                <S.box1 style={{marginTop:"10px", flexDirection:"column"}}>
                                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"8px"}}>
                                        <span style={{fontSize:"14px", fontWeight:"bold"}}>COTAÇÕES GERADAS:</span>
                                        <button
                                            type='button'
                                            onClick={handleNovaCotacao}
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: '#00D594',
                                                color: '#000',
                                                border: 'none',
                                                borderRadius: '4px',
                                                padding: '6px 10px',
                                                fontSize: '12px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Nova Cotação
                                        </button>
                                    </div>
                                    <div style={{display:"flex", flexDirection:"column", gap:"8px", maxHeight:"300px", overflowY:"auto"}}>
                                        <div style={{
                                            padding:"3px 10px",
                                            transition:"all 0.2s",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                        }}>
                                            <div style={{fontSize:"11px", color:"#ffffff"}}>DATA</div>
                                            <div style={{fontSize:"11px", color:"#ffffff"}}>ADESÃO</div>
                                            <div style={{fontSize:"11px", color:"#ffffff"}}>MENSAL</div>
                                            <div style={{fontSize:"11px", color:"#ffffff"}}>WHATSAPP</div>
                                            <div style={{fontSize:"11px", color:"#ffffff"}}>-</div>
                                            
                                        </div>
                                        {listaPesquisa.listaCotacao.map((cotacao, index) => (
                                            <div key={index} 
                                            style={{
                                                padding:"10px",
                                                border:"1px solid #ccc",
                                                borderRadius:"4px",
                                                backgroundColor:"#f9f9f9",
                                                transition:"all 0.2s",
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                            }}>
                                                <div style={{fontSize:"11px", color:"#999", cursor:"pointer"}} onClick={() => handleMostrarCotacao(cotacao)}>
                                                    {new Date(cotacao.data).toLocaleDateString('pt-BR')}
                                                </div>

                                                <div style={{fontSize:"11px", color:"#666", cursor:"pointer"}} onClick={() => handleMostrarCotacao(cotacao)}>
                                                    R$ {cotacao.valorAdesao?.toLocaleString('pt-BR')}
                                                </div>

                                                <div style={{fontSize:"11px", color:"#666", cursor:"pointer"}} onClick={() => handleMostrarCotacao(cotacao)}>
                                                    R$ {cotacao.valorCotacao?.toLocaleString('pt-BR')}
                                                </div>

                                                <div style={{fontSize:"11px", color:"#666", cursor:"pointer"}} onClick={() => handleMostrarCotacao(cotacao)}>
                                                    {cotacao.whatsapp
                                                        ? cotacao.whatsapp.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3')
                                                        : "N/A"}
                                                </div>

                                                <div style={{display:"flex", gap:"8px", alignItems:"center"}}>
                                                    <FaBan
                                                        title="Cancelar cotação"
                                                        style={{cursor:"pointer", color:"#d32f2f", fontSize:"16px"}}
                                                        onClick={() => handleCancelarCotacao(cotacao._id)}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </S.box1>
                            )}

                            {/* ------MODAL FLUTUANTE PARA ADICIONAR CELULAR -----*/
                            mostrarModalCelular && cpfValidado &&
                            <FoneCelular
                            setMostrarModalCelular={setMostrarModalCelular}
                            />
                            }
                        </S.div3>
                    </S.Container>
                    </>}

                    {
                    playmodal.playModalVeiculo &&
                    <S.Modal style={{zIndex:"3", position: "relative", top: "60px", bottom: 0}}>
                        <ModalVeiculo/>
                    </S.Modal>
                    }

                    {mostrarCotacao && (
                    <ModeloCotacao 
                        cliente={cliente}
                        veiculo={veiculo}
                        cotacao={cotacao}
                        usuario={usuario}
                        franquia={franquia}
                        CelularRepresentante={foneCelular.numeroCel}
                        onClose={() => {
                            setMostrarCotacao(false)
                            dispatch({type: 'set_veiculo', 
                                payload: {
                                    ...veiculo, 
                                    whatsapp_Cotacao: '',
                                    valorAdesao: "",
                                }});
                        }}
                    />
                    )}
                </S.VistoriaModal>
            </S.body>
            <Footer />
        </S.App>
    )
}
export default COTACAO;